// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","section":"footer_section__0NwCj","logo":"footer_logo__IRoNB","neverEndingChangesThreeMonthsLate":"footer_neverEndingChangesThreeMonthsLate__Bo0JW"};